import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=7080843d"
import script from "./Survey.vue?vue&type=script&lang=ts"
export * from "./Survey.vue?vue&type=script&lang=ts"
import style0 from "./Survey.vue?vue&type=style&index=0&id=7080843d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports